export default {
  myFiles: 'My documents',
  newDocument: 'New document',
  messages: 'Messages',
  addresses: 'Addresses',
  newAddress: '+ New address',
  aboutUs: 'About us',
  addArticle: 'Add article',
  addAttribute: 'Add attribute',
  addBank: 'Add bank',
  addBlog: 'Add news',
  addBrand: 'Add brand',
  addCategory: 'Add category',
  addCompany: 'Add company',
  addCountry: 'Add country',
  addCurrency: 'Add currency',
  addCustomerBankAccount: 'Add customer account',
  accountDetails: 'Profile details',
  addExpressPost: 'Add express post',
  addInterestsArea: 'Add industry',
  addMeasurementUnit: 'Add unit of measure',
  addPoll: 'Add poll',
  addProductSale: 'Add promotion',
  addTab: 'Add tab',
  blog: 'Blog',
  addTown: 'Add city',
  addToCart: 'Add to cart',
  addToCart2: 'To basket',
  docDate: 'Document date',
  account: 'Account',
  owes: 'Debits',
  comment: 'Comment',
  accountNumber: 'Account number',
  claims: 'Credits',
  paymentTerm: 'Payment term',
  bookingDateShort: 'Booking date',
  addUser: 'Add user',
  addVariation: 'Add variation',
  apply: 'Apply',
  article: 'Product',
  areYouSureArticle: 'Are you sure you want to delete article {article}?',
  areYouSureAttribute: 'Are you sure you want to delete attribute {attribute}?',
  areYouSureAttributeArticle: 'Are you sure you want to delete the attribute?',
  areYouSureAttributeValue:
    'Are you sure you want to delete the attribute value {attributeValue}?',
  areYouSureBank: 'Are you sure you want to delete bank {bank}?',
  areYouSureBlog: 'Are you sure you want to delete news {blog}?',
  areYouSureBrand: 'Are you sure you want to delete brand {brand}?',
  areYouSureCategory: 'Are you sure you want to delete category {category}?',
  areYouSureCompany: 'Are you sure you want to delete company {company}?',
  areYouSureCountry: 'Are you sure you want to delete country {country}?',
  areYouSureCurrency: 'Are you sure you want to delete currency {currency}?',
  areYouSureCustomerBankAccount:
    'Are you sure you want to delete customer bank account {bankAccount}?',
  areYouSureExpressPost: 'Are you sure you want to delete express post {post}?',
  areYouSureInterestsArea: 'Are you sure you want to delete industry {area}?',
  areYouSureProductSale: 'Are you sure you want to delete promotion {productSale}?',
  areYouSureSelected: 'Are you sure you want to delete selected records?',
  areYouSureTab: 'Are you sure you want to delete tab {tab}?',
  areYouSureTown: 'Are you sure you want to delete city {town}?',
  areYouSureUser: 'Are you sure you want to delete user {user}?',
  areYouSureCancelOrder: 'Are you sure you want to cancel the order?',
  areYouSureApproveOrder: 'Are you sure you want to approve the order?',
  areYouSureDeleteShoppingCart: 'Are you sure you want to delete the cart?',
  shoppingCartNotConcluded: 'You currently have an open cart.',
  shoppingCartItemsReplacement: 'Items in the cart will be replaced with items from the saved cart.',
  doYouWantToContinue: 'Do you want to continue?',
  thereAreCurrentlyNoSavedShoppingCarts: 'There are currently no saved carts.',
  articleDetails: 'Article details',
  articleDetailsInfo: 'Enter article details',
  articles: 'Articles',
  attributes: 'Attributes',
  banks: 'Banks',
  blogs: 'News',
  brands: 'Brands',
  brand: 'Brand',
  service: 'Service',
  cancel: 'Cancel',
  newRequest: 'New request',
  contactPerson: 'Contact person',
  categories: 'Categories',
  category: 'Category',
  serialNumber: 'Serial number',
  productCode: 'Product code',
  checkout: 'Checkout',
  download: 'Download',
  actions: 'Actions',
  sales: 'Promotions',
  folderIsEmpty: 'Your document folder is empty',
  physicalPersons: 'Individuals',
  goToCheckout: 'Go to checkout',
  choose: 'Choose',
  chooseOptions: 'Choose options',
  contact: 'Contact',
  onlineShopping: 'Online shopping',
  ord: 'No.',
  myAccount2: 'My account',
  myArticles: 'My products',
  followUsOnSocialMedia: 'Follow us on social media',
  deliveryAndPayment: 'Delivery and payment',
  complaintsAndReturns: 'Complaints and returns',
  securityAndPrivacy: 'Security and privacy',
  termsOfService: 'Terms of service and purchase',
  youNeedHelp: 'Need help?',
  from: 'From',
  to: 'To',
  title: 'Title',
  markAllAsRead: 'Mark all as read',
  faq: 'FAQ',
  howToRegister: 'How to register?',
  shoppingHelp: 'Shopping help',
  bonusProgramRules: 'Bonus program rules',
  comingSoon: 'Coming soon',
  companies: 'Companies',
  countries: 'Countries',
  countryDetails: 'Country details',
  countryDetailsInfo: 'Enter country details',
  viewFinances: 'View finances',
  coupons: 'Coupons',
  currencies: 'Currencies',
  customerBankAccounts: 'Customer accounts',
  profileDashboard: 'Dashboard',
  defaultAddress: 'The following addresses will be used by default on the checkout page.',
  delete: 'Delete',
  currentDebt: 'Current debt',
  deleteArticle: 'Delete article',
  paymentTerms: 'Payment terms',
  deleteAttribute: 'Delete attribute',
  debtOutsideCurrency: 'Debt outside currency',
  deleteBank: 'Delete bank',
  deleteBlog: 'Delete news',
  edit: 'Edit',
  approvedDebt: 'Approved debt',
  deleteBrand: 'Delete brand',
  deleteCategory: 'Delete category',
  notSetAnyAddressYet: 'You have not set any address yet.',
  deleteCompany: 'Delete company',
  deleteCountry: 'Delete country',
  deleteCurrency: 'Delete currency',
  deleteCustomerBankAccount: 'Delete customer bank account',
  deleteExpressPost: 'Delete express post',
  deleteInterestsArea: 'Delete industry',
  deleteProductSale: 'Delete promotion',
  deleteSelected: 'Delete selected',
  deleteTab: 'Delete tab',
  deleteTown: 'Delete city',
  deleteUser: 'Delete user',
  deleteVariationImage: 'Are you sure you want to delete the variation image?',
  details: 'Details',
  detailsInfo: 'Enter details',
  editArticle: 'Update article',
  editAttribute: 'Update attribute',
  editBank: 'Update bank',
  editBlog: 'Update news',
  editBrand: 'Update brand',
  editCategory: 'Update category',
  editCompany: 'Update company',
  editCountry: 'Update country',
  editCurrency: 'Update currency',
  editCustomerBankAccount: 'Update customer account',
  editExpressPost: 'Update express post',
  editInterestArea: 'Update industry',
  editPoll: 'Update poll',
  editProductSale: 'Update promotion',
  editTab: 'Update tab',
  editTown: 'Update city',
  editUser: 'Update user',
  expressPosts: 'Express posts',
  forgotPassword: 'Forgot password',
  greetings: 'Hello',
  homePageTitle: 'Home',
  highlightedCategories: 'Featured',
  import: 'Import',
  importArticles: 'Import articles',
  interestsAreas: 'Industries',
  cancel2: 'CANCEL',
  cancel3: 'Cancel',
  login: 'Login',
  logIn: 'Log in',
  logout: 'Logout',
  measurementUnits: 'Units of measure',
  myAccount: 'My profile',
  delete2: 'DELETE',
  myProfile: 'Profile',
  news: 'News',
  newArticles: 'New products',
  no: 'No',
  attention: 'Attention',
  warning: 'Warning',
  areYouSureYouWantToDeleteAcc: 'Are you sure you want to delete your account? Enter your password to delete your account.',
  areYouSureYouWantToDeleteAddress: 'Are you sure you want to remove the selected address?',
  noItemSelected: 'No records selected',
  noRecords: 'No results for the given parameters',
  notFound: 'Requested page not found',
  orderArticles: 'Articles in basket',
  orders: 'Orders',
  polls: 'Polls',
  priceRange: 'Price range',
  productSales: 'Promotions',
  recentlyViewdItems: 'Recently viewed',
  register: 'Register',
  filters: 'Filters',
  resetFilters: 'Reset filters',
  rma: 'Reported irregularities (RMA)',
  uploadAttachment: 'Attach images, files...',
  rmaForm: 'Complaints',
  save: 'Save',
  saveShoppingCart: 'Save cart',
  saveArticle: 'Save article',
  saveCategory: 'Save category',
  saveCountry: 'Save country',
  search: 'Search',
  find: 'Enter at least 3 characters...',
  selectAction: 'Select action',
  shoppingCart: 'Cart',
  tabs: 'Tabs',
  terms: 'Terms of use',
  townDetails: 'City details',
  townDetailsInfo: 'Enter city details',
  towns: 'Cities',
  total: 'Total',
  amount: 'Amount',
  topBrands: 'Top brands',
  userProfile: 'User profile',
  users: 'Users',
  userArticles: 'Products selected for you',
  viewAll: 'View all',
  viewAllFrom: 'View all from',
  addToCartSuccessMessage: 'You have just added an article to the <br/> basket: ',
  continueShopping: 'Continue shopping',
  clearShoppingCart: 'Clear basket',
  updateShoppingCart: 'Update basket',
  goToShoppingCart: 'Go to basket',
  wishlist: 'Wishlist',
  addToWishlist: 'Add to wishlist',
  yes: 'Yes',
  reviews: 'Review',
  tabReviews: 'Reviews',
  writeReview: 'Enter your review',
  submitReview: 'Submit review',
  anonymous: 'Anonymous',
  linkedArticles: 'Related products',
  quickPreview: 'Quick preview',
  loginRegisterTitle: 'Login / Create account',
  loginTitle: 'Login',
  loginSubTitle: 'If you have an account, log in.',
  loginButton: 'LOGIN',
  registerTitle: 'Request an account',
  registerSubTitle: 'Fill in the required information and our team will contact you as soon as possible and create your account. Thank you!',
  chooseCountry: 'Choose country',
  chooseTown: 'Choose city',
  registerSectionLoginDataTitle: 'Login data',
  acceptTerms: 'I accept the terms of use',
  registerSubmit: 'Request account',
  repeatOrder: 'Repeat order',
  close: 'Close',
  defaultSort: 'Default sorting',
  sortByRating: 'Sort by rating',
  sortByDateOldest: 'Sort by publish date: oldest to newest',
  sortByDateNewest: 'Sort by publish date: newest to oldest',
  sortByPriceLow: 'Sort by price: low to high',
  sortByPriceHigh: 'Sort by price: high to low',
  pagingResults: 'Showing {fromResults} - {toResults} of {totalItems} results',
  showMore: 'Show more',
  productIsAvalible: 'Product is available',
  productIsAvalibleToOrder: 'Product is available on order',
  deliveryTimeDays: 'Delivery time is {days} days from order',
  itemIsAvalibleContactRepresentative: 'Item is available on order. Please contact your sales representative.',
  availableOnRequest: 'Available on request',
  requestPresentation: 'Request presentation',
  howDoYouRateThisProduct: 'How do you rate this product?',
  administrator: 'Administrator',
  passwordRecovery: 'Password recovery',
  enterYourEmailAddressBelowAndWellSendYouInstructions: 'Enter your email address below and we will send you reset instructions!',
  reset: 'Reset',
  remembered: 'Remembered',
  finances: 'Finances',
  allRightsReserved: 'All rights reserved',
  updateAddress: 'Update address',
  state: 'State',
  chooseState: 'Choose state',
  listIsEmpty: 'List is empty',
  noResultsAccordingToTheGivenParameters: 'No results for the given parameters',
  termsOfUseIsMandatory: 'The Terms of Use field is required',
  resetPassword: 'Reset password',
  accVerificationInProgress: 'Account verification in progress',
  accVerification: 'Account verification',
  verificationLinkHasExpired: 'Verification link has expired. Please contact our administrators: support@eurosan.ba or +387 36 342 220.',
  youHaveJustAddedAnItemToTheCart: 'You have just added an article to the basket:',
  manufacturer: 'Manufacturer',
  productName: 'Product name',
  shoppingCarts: 'Baskets',
  preview: 'Preview',
  documentName: 'Document name',
  status: 'Status',
  orderNumber: 'Order number',
  orderer: 'Orderer',
  date: 'Date',
  document: 'Document',
  delivery: 'Delivery',
  deliverTo: 'Deliver to',
  discount: 'Discount',
  savingsByUsingPromoCode: 'Savings using promo code',
  itemAddedToCart: 'Item added to basket.',
  articlesOnSale: 'Artikli na akciji',
  controlPanel: 'Kontrolna ploča',
  tags: 'Tagovi',
  totalAmountWithDelivery: 'Ukupno sa dostavom',
  youHaveNotPlacedAnorderYet: 'Niste još uvijek napravili narudžbu',
  quantity: 'Količina',
  amountWithoutVat: 'Iznos bez PDV-a',
  vatAmount: 'Iznos PDV-a',
  orderNo: 'Narudžba br',
  days: 'dana',
  time: 'Vrijeme',
  quantity2: 'KOLIČINA',
  rejectOrd: 'Odbij nar',
  approveOrd: 'Odobri nar',
  wishListIsEmpty: 'Lista želja prazna',
  sale: 'AKCIJA',
  totalWithoutTax: 'Ukupno bez poreza',
  sendRequest: 'POŠALJI ZAHTJEV',
  promoCode: 'Promo kod',
  send: 'Pošalji',
  registrationCode: 'Šifra prijave',
  created: 'Kreirano',
  giftCard: 'Poklon kod',
  changePassword: 'Promjena lozinke',
  emailAddress: 'Email adresa',
  oldPassword: 'Stara lozinka',
  deleteUserAcc: 'IZBRIŠI KORISNIČKI RAČUN',
  permanentlyDeletedAcc: 'Korisnički račun će biti trajno obrisan',
  confirmNewPassword: 'Potvrdite novu lozinku',
  passwordConfirmation: 'Potvrda lozinke',
  newPassword: 'Nova lozinka',
  newPassLeaveBlank: 'Nova lozinka (ostavite prazno ukoliko ne želite mijenjati)',
  currentPassLeaveBlank: 'Trenutna lozinka (ostavite prazno ukoliko ne želite mijenjati)',
  areasOfInterest: 'Interesna područja',
  chooseAreaOfInterest: 'Izaberite interesna područja',
  totalTax: 'Ukupno poreza',
  price: 'Cijena',
  price2: 'PRICE',
  newAddress2: 'New address',
  show: 'Show',
  stock: 'Stock',
  yourTotalDebtIs: 'Your total debt is',
  isInStock: 'In stock',
  print: 'Print',
  signUpForTheNewsletter: 'Sign up for the newsletter',
  latestInformations: 'Get all the latest information about events, sales and offers.',
  subscribe: 'Subscribe',
  aboutEurosanGroup: 'About Eurosan Group',
  responsibleBusiness: 'Responsible business',
  noDataToAccordingData: 'No data for the requested parameters',
  jobAtEurosan: 'Job at Eurosan',
  vpc: 'Wholesale price',
  products: 'products',
  phoneNumber: 'Phone number',
  tax: 'VAT',
  tax2: 'Tax',
  defaultAddress2: 'Default address',
  totalWithVat: 'Total with VAT',
  totalWithoutVat2: 'Total without VAT',
  summary: 'Summary',
  warranty: 'Warranty',
  zipCode: 'Zip code',
  indeterminate: 'Indeterminate',
  description: 'Description',
  completeSolutionsForYourBusiness: 'Complete solutions for your business success',
  whoAreWe: 'WHO ARE WE',
  about: {
    aboutEurosan: 'Eurosan Ecotime Group was founded in 1998 inspired by the desire for healthier and happier workspaces. Our goal is clear: to be your reliable partner in maintaining cleanliness, hygiene, and safety. We believe that a clean and safe work environment drives success.',
    aboutEurosan2: '"Healthier, safer, more productive" - that is our promise to you!',
    aboutEurosan3: 'Through our comprehensive services and products - from professional cleaning to environmentally friendly products and protective equipment - we create spaces where people breathe easier, work more efficiently, and live healthier.',
    aboutEurosan4: 'Choose us and join us in creating a healthier and safer future.',
    ourMission: 'OUR MISSION',
    mission: 'To be your reliable partner in creating a clean, safe, and sustainable environment through tailored solutions and exceptional service.',
    ourVision: 'OUR VISION',
    vision: 'To become a leader in providing sustainable and tailored solutions for a cleaner, healthier, and safer future, always putting our clients’ needs first.',
    ourValues: 'OUR VALUES',
    values: 'Our core values define who we are, what we do, and how we do it: high quality of services and products, hygiene knowledge, and care for the safety and health of people.',
    whyChooseUs: 'WHY CHOOSE US?',
    efficiency: 'EFFICIENCY:',
    efficiencyText: 'Clean smarter, work less.',
    improvedHygiene: 'IMPROVED HYGIENE:',
    improvedHygieneText: ' Exceptional level of hygiene for every space.',
    effectiveCleaning: 'EFFECTIVE CLEANING:',
    effectiveCleaningText: ' The power of cleanliness in every package.',
    improvedWorkerSafety: 'IMPROVED WORKER SAFETY:',
    improvedWorkerSafetyText: ' Protect your workers with top-quality protective equipment.',
    improvedDineExperience: 'IMPROVED DINING EXPERIENCE:',
    improvedDineExperienceText: ' An atmosphere that exudes luxury and quality.',
    greaterGuestSatisfaction: 'GREATER GUEST SATISFACTION:',
    greaterGuestSatisfactionText: ' Environmentally friendly hotel cosmetics of top quality.',
    timeSaving: 'TIME SAVING:',
    timeSavingText: ' Save time and energy - leave the cleaning to us.',
    longerEquipmentLife: 'LONGER EQUIPMENT LIFE:',
    longerEquipmentLifeText: ' For peace of mind - your equipment in the safe hands of our service.',
    atService: 'Proudly serving more than ',
    threeThousandClients: '3,000 clients',
    inCountries: 'in BiH, Serbia, and Montenegro',
    yearsOfExistence: 'Years of existence',
    numberOfEmployees: 'Employees',
    activeArticles: 'Active articles',
  },
  recentBlogs: 'Recent news',
  readMore: 'Read more',
  searchFor: 'Search',
  archive: 'Archive',
  payment: 'Payment',
  deliveryAddress: 'Delivery address',
  deliverHere: 'Deliver here',
  deliveryAddressValidationMessage: 'Please enter at least one delivery address before proceeding with the order',
  deliveryMethod: 'Delivery method',
  free: 'Free',
  deliveryTime: 'Delivery time 2 to 3 business days',
  personalPickup: 'Personal pickup',
  personalVisitToTheBranch: 'Personal visit to the branch',
  ourDelivery: 'Our delivery',
  deliverySevenDays: 'Delivery time approx. 7 days',
  orderAmountFromText: '*Order amount from ',
  getFreeDeliveryText: ' KM grants you free delivery',
  articlesInShoppingCart: ' items in basket',
  areYourSureEmptyShoppingCart: 'Are you sure you want to empty your shopping cart?',
  orderTotalAmountWithoutVat: 'Order total (without VAT): ',
  orderTotalBruttoWeight: 'Total weight ',
  promoCodeDiscount: '*Savings when using promo code: ',
  postage: 'Postage',
  totalOrderAmountWithPostage: 'Total with postage: ',
  paymentMethod: 'Payment method',
  note: 'Note',
  acceptTermsOfUse: 'I accept the terms of use',
  back: 'Back',
  placeOrder: 'Place order',
  nextStep: 'NEXT',
  complaints: {
    complaints: 'Complaints',
    privateBuyers: 'For private customers:',
    text1: 'If you find, upon first use (within 7 days of receipt), that the product you received is defective, please contact us and follow these steps:',
    text2: 'Send us information with the order number, invoice number, or your username and a description of the complaint via',
    emailAddress: ' email address ',
    phone: 'or by phone at ',
    text3: 'We will send you a confirmation of receipt of the complaint and, based on your description, information on whether the product can be replaced with a new one and whether a refund is possible.',
    text4: 'If the product can be replaced with a new one or refunded, we will send a delivery service to your address to collect the claimed product and return it to our warehouse. Your obligation is to pack the product and prepare it for pickup by the courier in the original packaging with all accessories and documentation received with the product. Once the product arrives at the warehouse and is inspected, we will notify you about the refund/replacement. The refund/replacement will be processed within 2-3 days, and no later than 15 days. Otherwise, contact us by phone at 080 080 080 or by email at webshop@eurosan.ba',
    text5: 'If the packaging is damaged, do not accept the product; instead, inform the courier about the damage and request that the product be returned to Eurosan. If the customer does not report packaging damage to the courier at the time of receipt, it is considered that the product was received with undamaged packaging.',
    text6: 'If the product you received does not match the image or specification of the ordered product, you can exchange or return it for a refund within 7 days of receipt. To exercise this right, the undamaged product must be sent in the original packaging with all equipment and documentation with which it was originally delivered.',
    businessCustomers: 'For business customers: ',
    text7: 'Business customers fill out a form called "Complaints" to send complaints to Eurosan d.o.o. On the eurosan.ba webshop, in the "My profile" section, there is a form where you enter the contact person, product name and code, brand, serial number, description, attach a picture, and enter the invoice number. Finally, click send, and you can track the status of your complaint in the same place, whether it is pending or completed. You can also send a request if you need to service a machine that is not working. In that case, it is very important to send pictures so that Eurosan service technicians know exactly what it is about.',
    text8: 'For all additional information, you can contact your sales representative, call us at',
    text9: '080 080 080 or send an email to ',
  },
  contactUs: {
    commercialist: 'Sales representative',
    eurosan: 'Eurosan d.o.o.',
    workTimeText: 'Working hours',
    workTime1: 'Monday - Friday: 07:30-16:00',
    workTime2: 'Saturday (from June to October): 08:00-12:00',
    address1: 'Bišće polje bb, 88000 Mostar',
    ecotime: 'Ecotime d.o.o.',
    workTime3: 'Monday - Friday: 08:00-16:00',
    workTime4: 'Saturday: 08:00-12:00',
    address2: 'Lužansko polje 7, 71210 Ilidža',
    eurosanBl: 'Eurosan Banja Luka d.o.o.',
    workTime5: 'Saturday: 09:00-13:00',
    address3: 'Jovana Bijelića bb, 78000 Banja Luka',
  },
  FAQ: {
    faq: 'Frequently Asked Questions / FAQ',
    text1: ' To make it easier to navigate our webshop, we have answered your most common questions. We believe the answers will help you order your desired product more easily, quickly, and without doubts.',
    q1: 'How to register and create a profile?',
    text2: 'When you open our webshop, you will need to request a user account by filling in the required information. After that, our team will contact you as soon as possible and create your user account. The information you need to fill in includes: name and surname, company, phone, address, country, city, and areas of interest. For areas of interest, it is important to select the sector you belong to and work in, whether it is healthcare, hospitality, gyms, manufacturing, or another offered option.',
    text3: 'You can shop without creating a user account, as a guest. You only need to enter your delivery information and email so we can send you a confirmation of a successful purchase. You can also log in via Facebook and Google platforms offered.',
    q2: 'How to order products?',
    text4: 'Ordering is very simple: open the article you want to order, click "add to basket", or in the quick view click the appropriate icon in the top right corner of the image. When you finish adding articles, open the cart and proceed to checkout. Choose the delivery address, delivery method, and payment method. Finally, click "place order" and your order will be sent. You will receive a confirmation of your order by email.',
    text5: 'Open the article you want to order and add it to the basket. When you finish adding articles, open the cart and proceed to checkout. Fill in the required information: name and surname, address, email address, phone number, and payment method. Finally, click "place order" and your order will be sent. You will receive a confirmation of your order by email.',
    q3: 'How is delivery done?',
    text6: 'Business customers have several delivery options:',
    eurosanFreeDelivery: 'Eurosan free delivery',
    postDelivery: 'delivery by express mail (Hrvatska pošta Mostar)',
    text7: 'personal pickup in Mostar, Sarajevo, and Banja Luka, i.e., in Group companies',
    text8: 'Delivery is done by express mail. (Hrvatska Pošta Mostar with a delivery time of 24h)',
    text9: 'Customers can also personally pick up the order in one of our offices in Mostar, Sarajevo, or Banja Luka.',
    q4: 'Are your products suitable for small businesses?',
    text10: 'Yes, our products are suitable for large companies, small businesses, enterprises, as well as private users and households.',
    q5: 'Do you offer presentations, training, or support for your products?',
    businessCustomers: 'Business customers:',
    text11: 'Business customers have the option of product presentations for certain products such as cleaning machines, specific chemical programs, cleaning aids, etc. For every purchased product, customers will have training where our experts will explain how to use the product. Also, on the webshop, each article contains technical documentation and usage instructions. Each customer has their sales representative for support in using the products.',
    text12: 'For any questions, business customers can always contact our free info phone',
    text13: ' 080 080 080 or send us an email at ',
    privateBuyers: 'Private customers:',
    text14: 'Private customers can contact us via the free info phone ',
    text15: 'or through other communication channels, always for help, advice, and the right choice of products for their needs in private purposes and households. Customer support is always available.',
    q6: 'Which credit cards do you accept?',
    text16: 'In addition to cash payment, private customers can also pay with VISA, MasterCard, and Maestro cards.',
    q7: 'Do you deliver products outside BiH?',
    text17: 'No. Our market is local and covers only the territory of Bosnia and Herzegovina. However, we have two partner companies, Interesta d.o.o. in Montenegro and Ecotime d.o.o. Belgrade in Serbia. For more information, feel free to contact us.',
  },
  newsletterConfirm: {
    backToShop: 'Back to shop',
    great: 'Great!',
    subscribed: 'You have subscribed to the Eurosan Newsletter',
  },
  passwordResetSuccess: 'Lozinka uspješno obnovljena',
  backToLogin: 'Povratak na prijavu',
  addSelected: 'Dodaj odabrane',
  service2: {
    text1: 'Eurosan d.o.o. garantira da svi proizvodi do roka predaje kupcu posjeduju kvalitetu i da su isti bez nedostataka kao i da se mogu koristiti u skladu sa deklariranom namjenom, sukladno deklaraciji proizvođača.',
    text2: 'Kupac je u obavezi da prilikom prijema naručenog proizvoda isti pregleda i utvrdi da li ima nedostataka. Ukoliko se nedostaci utvrde isti će biti otklonjeni u garantnom roku.',
    text3: ' Dužina garantnog roka je navedena u garantnom listu, ukoliko proizvod posjeduje isti.',
    text4: ' U slučaju da je proizvod isporučen sa nedostatkom, kupac ima pravo na zamjenu istoga.',
    text5: 'Od reklamacija su izuzeti nedostaci koji su prouzrokovani nestručnim rukovanjem i suprotno uputstvu proizvođača za rukovanje proizvodima.',
    text6: 'Reklamacije proizvoda se priznaju uz predočeni fiskalni račun i ispravno popunjeni garantni list kao dokaz kupovine. U slučaju reklamacije proizvoda informacije o načinu prijave kvara ili slanju ovlaštenom servisu informacije potražite na garantnom listu isporučenom uz proizvod ili nas ',
    text7: ' kontaktirajte na kontakt telefon 080 080 080 ili putem email adrese ',
    text8: 'Za popravku proizvoda isporučenih od strane Eurosan d.o.o. osigurali smo kvalitetnu uslugu kako u garantnom periodu tako i izvan njega. Naše osoblje servisa stoji vam na raspolaganju za savjete u vezi upotrebe proizvoda, kvarovima te mogućnostima popravke istoga.',
  },
  areYouSureEmptyShoppingCart: 'Da li ste sigurni da želite isprazniti košaricu?',
  discountCode: 'Discount code',
  remove: 'Remove',
  yourCartIsEmpty: 'Your cart is empty',
  vpPrice: 'Wholesale price',
  howToRegisterText: 'How to register - User guide',
  downloadOurApp: 'Download our app',
  mobileAppViewText: 'Enjoy fast and safe shopping with the best discounts and new products!',
  bih: 'Bosnia and Herzegovina',
  jajce: 'Jajce',
  mostar: 'Mostar',
  sarajevo: 'Sarajevo',
  banjaluka: 'Banja Luka',
  sirokiBrijeg: 'Široki Brijeg',
  bihac: 'Bihać',
  kozarskaDubica: 'Kozarska Dubica',
  teslic: 'Teslić',
  derventa: 'Derventa',
  forms: {
    notValid: 'Entered data is not valid!',
    labels: {
      username: 'Username',
      abbreviation: 'Abbreviation',
      address: 'Address',
      email: 'Email address',
      articleType: 'Article type',
      availableValues: 'Available values',
      bank: 'Bank',
      bankAccount: 'Bank account',
      brand: 'Brand',
      catalogNumber: 'Catalog number',
      category: 'Category',
      code: 'Code',
      company: 'Company',
      content: 'Content',
      country: 'Country',
      countryName: 'Country name',
      defaultPrice: 'Default price',
      description: 'Description',
      fax: 'Fax',
      interestsArea: 'Industry',
      isVisibleOnWeb: 'Visible on web',
      mpc: 'Retail price',
      name: 'Name',
      nc: 'Purchase price',
      nettoWeight: 'Net weight',
      officeNumber: 'Office number',
      phone: 'Phone',
      password: 'Password',
      confirmPassword: 'Repeat password',
      shortDescription: 'Short description',
      symbol: 'Simbol',
      taxGroup: 'Tax group',
      title: 'Title',
      town: 'City',
      townName: 'City name',
      unit: 'Unit',
      unitOfMeasure: 'Unit of measure',
      videoUrl: 'Video link',
      vpc: 'Wholesale price',
      firstName: 'First name',
      lastName: 'Last name',
    },
    errors: {
      default: 'An error occurred during validation.',
      email: 'Field {field} is not a valid email.',
      integer: 'Field {field} must be a number.',
      minLength: 'Minimum {count} characters.',
      required: 'Field {field} is required.',
      sameAs: 'Field {field} and field {field2} do not match.',
      url: 'Field {field} is not a valid url.',
    },
  },
  tables: {
    email: 'Email',
    firstLastName: 'First and last name',
    id: 'ID',
    name: 'Name',
    phone: 'Phone',
    town: 'City',
    username: 'Username',
  },
};
